module.exports = __webpack_public_path__ + "img/hook.9450be40.svg";